export default __webpack_public_path__ + "static/media/nextuLogo.beef05e3.webp";